import script from "./InfoIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&setup=true&lang=ts"

import "./InfoIcon.vue?vue&type=style&index=0&id=3d44c765&lang=css"

const __exports__ = script;

export default __exports__